export default __webpack_public_path__ + "static/media/10.c753b2f9.png";